import type { AudioError } from "@/types/audio";
import { Mic } from "lucide-react";

interface RecordButtonProps {
  isRecording: boolean;
  isPlaying: boolean;
  error: AudioError | null;
  onToggle: () => void;
}

export function RecordButton({
  isRecording,
  isPlaying,
  error,
  onToggle,
}: RecordButtonProps) {
  return (
    <button
      className={`group relative flex h-full w-full items-center justify-center rounded-full transition-colors
        ${
          isRecording
            ? "bg-red-500 hover:bg-red-600"
            : isPlaying
              ? "bg-green-500 hover:bg-green-600"
              : error
                ? "bg-yellow-500 hover:bg-yellow-600"
                : "bg-gray-800 hover:bg-gray-700"
        }`}
      onClick={onToggle}
    >
      <Mic
        className={`h-8 w-8 transition-colors ${
          isRecording || isPlaying ? "text-white" : "text-gray-400"
        }`}
      />
      <div
        className={`absolute -inset-1 animate-ping rounded-full 
        ${isRecording ? "bg-red-500/60" : "hidden"}`}
      />
    </button>
  );
}
